<div class="logistics-control-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Live Operations Board</p>
      <h2>Control Tower</h2>
      <p class="subtitle">Run the day from one board: dispatch queues, fleet gaps, maintenance escalation, and payment exposure.</p>
    </div>
    <button mat-stroked-button (click)="loadBoard()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="hero-strip">
    <article class="hero-tile">
      <span>Pending Queue</span>
      <strong>{{ pendingActivities.length }}</strong>
      <small>Orders waiting for assignment or dispatch action</small>
    </article>
    <article class="hero-tile">
      <span>In Transit</span>
      <strong>{{ transitActivities.length }}</strong>
      <small>Deliveries currently on the road</small>
    </article>
    <article class="hero-tile">
      <span>Delivered</span>
      <strong>{{ deliveredCount }}</strong>
      <small>Completed activity records captured so far</small>
    </article>
    <article class="hero-tile critical">
      <span>Cash Exposure</span>
      <strong>{{ cashExposure | number:'1.0-0' }}</strong>
      <small>Value of unpaid deliveries still outstanding</small>
    </article>
  </section>

  <section class="board-grid">
    <article class="panel">
      <div class="panel-head">
        <h3>Pending</h3>
        <span>{{ pendingActivities.length }} items</span>
      </div>
      <div class="lane-list" *ngIf="pendingActivities.length; else noPending">
        <div class="lane-card" *ngFor="let row of pendingActivities">
          <strong>{{ row.trackingId }}</strong>
          <p>{{ row.customerName || 'Customer not set' }}</p>
          <small>{{ row.receiverName || 'Receiver not set' }}</small>
        </div>
      </div>
    </article>

    <article class="panel">
      <div class="panel-head">
        <h3>Assigned</h3>
        <span>{{ assignedActivities.length }} items</span>
      </div>
      <div class="lane-list" *ngIf="assignedActivities.length; else noAssigned">
        <div class="lane-card" *ngFor="let row of assignedActivities">
          <strong>{{ row.trackingId }}</strong>
          <p>{{ row.customerName || 'Customer not set' }}</p>
          <small>Rider: {{ row.assignedRider || 'Unassigned' }}</small>
        </div>
      </div>
    </article>

    <article class="panel">
      <div class="panel-head">
        <h3>In Transit</h3>
        <span>{{ transitActivities.length }} items</span>
      </div>
      <div class="lane-list" *ngIf="transitActivities.length; else noTransit">
        <div class="lane-card accent" *ngFor="let row of transitActivities">
          <strong>{{ row.trackingId }}</strong>
          <p>{{ row.customerName || 'Customer not set' }}</p>
          <small>Rider: {{ row.assignedRider || 'Unassigned' }}</small>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Maintenance Alerts</h3>
        <span>{{ maintenanceAlerts.length }} critical</span>
      </div>
      <div class="metric-list" *ngIf="maintenanceAlerts.length; else noMaintenance">
        <div class="metric-row" *ngFor="let row of maintenanceAlerts">
          <strong>{{ row.vehiclePlate }}</strong>
          <span>{{ row.daysSinceLastMaintenance || 0 }} days</span>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Inactive Riders</h3>
        <span>{{ inactiveRiders.length }} listed</span>
      </div>
      <div class="metric-list" *ngIf="inactiveRiders.length; else noInactiveRiders">
        <div class="metric-row" *ngFor="let row of inactiveRiders">
          <strong>{{ row.fullName }}</strong>
          <span>{{ row.assignedPhoneModel || 'No phone model' }}</span>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Unassigned Vehicles</h3>
        <span>{{ unassignedVehicles.length }} ready</span>
      </div>
      <div class="metric-list" *ngIf="unassignedVehicles.length; else noUnassignedVehicles">
        <div class="metric-row" *ngFor="let row of unassignedVehicles">
          <strong>{{ row.plateNumber }}</strong>
          <span>{{ row.model || row.type || 'Vehicle' }}</span>
        </div>
      </div>
    </article>

    <article class="panel wide">
      <div class="panel-head">
        <h3>Recent Maintenance Records</h3>
        <span>Latest 6 updates</span>
      </div>
      <div class="record-list" *ngIf="recentMaintenanceRecords.length; else noRecords">
        <div class="record-item" *ngFor="let row of recentMaintenanceRecords">
          <div>
            <strong>{{ row.vehiclePlate }}</strong>
            <p>{{ row.description || row.recordType }}</p>
          </div>
          <div class="record-meta">
            <span>{{ row.recordType }}</span>
            <small>{{ row.serviceDate | date:'mediumDate' }} · {{ row.cost || 0 | number:'1.0-0' }}</small>
          </div>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #noPending>
  <p class="muted">No pending activity records right now.</p>
</ng-template>

<ng-template #noAssigned>
  <p class="muted">No assigned deliveries right now.</p>
</ng-template>

<ng-template #noTransit>
  <p class="muted">No in-transit deliveries right now.</p>
</ng-template>

<ng-template #noMaintenance>
  <p class="muted">No active maintenance alerts.</p>
</ng-template>

<ng-template #noInactiveRiders>
  <p class="muted">No inactive riders currently listed.</p>
</ng-template>

<ng-template #noUnassignedVehicles>
  <p class="muted">All active vehicles are assigned.</p>
</ng-template>

<ng-template #noRecords>
  <p class="muted">No maintenance records available yet.</p>
</ng-template>
